 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHTITLE from '@/components/xhtml/Htitle'
 import XHTMLEDITORS from '@/components/xhtml/Editors'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLFRONT from '@/components/xhtml/Front'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLPREFACE from '@/components/xhtml/Preface'
 import XHTMLACK from '@/components/xhtml/Ack'
 import XHTMLNOTE1 from '@/components/xhtml/Note1'
 import XHTMLABBRIVATIONS from '@/components/xhtml/Abbrivations'
 import XHTMLINTRODUCTION from '@/components/xhtml/Introduction'
 import XHTMLCHAPTER01 from '@/components/xhtml/Chapter01'
 import XHTMLCHAPTER02 from '@/components/xhtml/Chapter02'
 import XHTMLCHAPTER03 from '@/components/xhtml/Chapter03'
 import XHTMLCHAPTER04 from '@/components/xhtml/Chapter04'
 import XHTMLCHAPTER05 from '@/components/xhtml/Chapter05'
 import XHTMLCHAPTER06 from '@/components/xhtml/Chapter06'
 import XHTMLCHAPTER07 from '@/components/xhtml/Chapter07'
 import XHTMLCHAPTER08 from '@/components/xhtml/Chapter08'
 import XHTMLCONCLUSION from '@/components/xhtml/Conclusion'
 import XHTMLNOTES from '@/components/xhtml/Notes'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/Bibliography'
 import XHTMLINDEX from '@/components/xhtml/Index'
 import XHTMLBACK from '@/components/xhtml/Back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Preface",
 			"name" : "xhtml/Preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/Ack",
 			"name" : "xhtml/Ack",
 			"component" : XHTMLACK
 		},
 		{
 			"path" : "/xhtml/Note1",
 			"name" : "xhtml/Note1",
 			"component" : XHTMLNOTE1
 		},
 		{
 			"path" : "/xhtml/Abbrivations",
 			"name" : "xhtml/Abbrivations",
 			"component" : XHTMLABBRIVATIONS
 		},
 		{
 			"path" : "/xhtml/Introduction",
 			"name" : "xhtml/Introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/Chapter01",
 			"name" : "xhtml/Chapter01",
 			"component" : XHTMLCHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js